export const lotItemStyle = {
	buttonWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},

	category: {
		marginBottom: '4px',
		color: 'var(--neutral-300)',
	},

	textWrapper: {
		padding: '12px',
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		justifyContent: 'space-between',

		'@media (max-width: 639.98px)': {
			padding: '8px',
		},
	},

	wrapper: {
		borderRadius: '8px',
		border: '1px solid var(--neutral-100)',
		// cursor: 'pointer',
		transition: 'boxShadow var(--transition)',
		position: 'relative',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		maxHeight: '450px',

		'&:hover': {
			boxShadow: 'var(--box-shadow--3)',
		},

		'@media (min-width: 1200px)': {
			maxHeight: '380px',
		},
	},

	image: {
		'& img': {
			borderTopLeftRadius: '8px',
			borderTopRightRadius: '8px',
			width: '100%',
			height: '120px',
			objectFit: 'cover',
			cursor:'pointer',

			'@media (max-width: 1199.98px)': {
				height: '180px',
			},

			'@media (max-width: 768px)': {
				height: '160px',
			},

			'@media (max-width: 425px)': {
				height: '120px',
			},
		},
	},

	bid: {
		display: 'flex',
		flexDirection: 'column',
		color: 'var(--neutral-300)',

		'&:first-child': {
			paddingRight: '32px',
			borderRight: '1px solid var(--neutral-100)',
		},
	},

	bidWrapper: {
		display: 'flex',
		gap: '16px',
		marginBottom: '12px',
	},

	auctionType: {
		background: 'var(--default-white)',
		position: 'absolute',
		top: '8px',
		right: '8px',
		color: 'var(--primary-500)',
		borderRadius: '50px',
		padding: '0 12px',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '972px',
			padding: '48px 12px',
			width: '100%',
		},
	},

	modalLogin: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 200px',
			width: '100%',

			'@media (max-width: 1199.98px)': {
				padding: '40px 60px',
			},

			'@media (max-width: 639.98px)': {
				padding: '32px 16px',
			},
		},
	},

	modalBid: {
		'.MuiPaper-root': {
			maxWidth: '972px',
			padding: '48px 200px',
			width: '100%',

			'@media (max-width: 1199.98px)': {
				padding: '48px 80px',
			},

			'@media (max-width: 639.98px)': {
				padding: '40px 20px',
			},

			'.MuiBox-root': {
				width: '100%',
			},
		},
	},

	button: {
		fontSize: '14px',
		whiteSpace: 'nowrap',
		padding: '6px 4px',

		'@media (max-width: 639.98px)': {
			fontSize: '12px',
		},
	},
	imagePlaceholder: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		background: 'var(--neutral-100)',
		width: '100%',
		height: '120px',
		objectFit: 'cover',
		flexShrink: 0,
		borderRadius: '4px',

		'@media (max-width: 1199.98px)': {
			height: '180px',
		},

		'@media (max-width: 768px)': {
			height: '160px',
		},

		'@media (max-width: 425px)': {
			height: '120px',
		},

		svg: {
			height: '30px',
			width: '30px',

			path: {
				fill: 'var(--neutral-300)',
			},
		},
	},
	buyNowButton: {
		height: '40px',
	},
};
